import { isFeatureEnabled } from "./appConfigurations";

// Gates the Audit log page, CS AB#50137: the events in a table at /std/audlg,
// opened from the sidebar. Off = the Audit log dialog as it was before, which
// only exports.
export const AUDIT_LOG_PAGE_FEATURE_FLAG = "CS_50137_AUDIT_LOG_PAGE";

export const selectAuditLogPageEnabled = isFeatureEnabled(AUDIT_LOG_PAGE_FEATURE_FLAG);
